var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"globalLoading"}},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}})],1),_vm._v(" "),(_vm.isNavbar)?_c('div',{staticClass:"nav shadow-sm bg-light",staticStyle:{"z-index":"1038"}},[_c('navbar')],1):_vm._e(),_vm._v(" "),_c('div',{class:{ 'offset-y': _vm.isNavbar }},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ad7f3cd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 